export default __webpack_public_path__ + "static/media/portfolio-159.dee8fa6b.jpg";